import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const getToken = () => localStorage.getItem("token");

export const getDashboard = async () => {
    return axios.get(`${API_BASE_URL}/admin/dashboard`, {
        headers: { token: getToken() },
    });
};

export const getPartnerDashboard = async () => {
    return axios.get(`${API_BASE_URL}/admin/partner-dashboard`, {
        headers: { token: getToken() },
    });
};

export const getNotifications = async () => {
    return axios.get(`${API_BASE_URL}/admin/notifications`, {
        headers: { token: getToken() },
    });
};

export const getPartnerNotifications = async () => {
    return axios.get(`${API_BASE_URL}/admin/partner-notifications`, {
        headers: { token: getToken() },
    });
};

export const markNotificationAsRead = (notificationId) => {
    return axios.put(`${API_BASE_URL}/admin/notifications/${notificationId}/read`, {}, {
        headers: { token: getToken() },
    });
};

